
import React, { Component, useState } from 'react';
import { FormControl, Select, MenuItem, InputLabel, TextField} from '@mui/material';
import moment from 'moment';

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { useSelector } from 'react-redux';

dayjs.extend(relativeTime)


const DateOfBirth = (props) => {
    const [value, setValue] = useState(props.question.Responses[0].Response || null )
    const minDate = dayjs().subtract(props.question.ValueLimitationMin, 'year')
    const maxDate = dayjs().subtract(props.question.ValueLimitationMax, 'year')
    const { viewInstance, settings } = useSelector(state => state.viewinstance)


    const handleChange = (value) => {
        if( dayjs().diff(dayjs(value), 'year') >= props.question.ValueLimitationMin  && 
            dayjs().diff(dayjs(value), 'year') <= props.question.ValueLimitationMax ){
         
            setValue(value)
        }
    }

    const handleSave = () => {
        
        if(dayjs().diff(dayjs(value), 'year') >= props.question.ValueLimitationMin  && 
        dayjs().diff(dayjs(value), 'year') <= props.question.ValueLimitationMax ){

            props.saveAnswer(dayjs(value).format('MM-DD-YYYY'))

        }
    }

    return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                 <DatePicker
                     openTo="year"
                     views={['year', 'month', 'day']}
                     label={props.question.QuestionStandardContent}
                     disableFuture
                     value={value}
                     onChange={(newValue) => {
                     handleChange(newValue);
                     }}
                     onClose={handleSave}
                     onBlur={handleSave}
                     renderInput={(params) => <TextField {...params} helperText={viewInstance?.SurveyPage?.OtherLabels?.SelectDate ||"Please select a date."} onBlur={handleSave} />}
                 />

        </LocalizationProvider>
    )
}

//helps generate an array of Dropdown items within a number range
function optionGenerator(start, end, dir){
    var options = []

    if(dir=="ASC"){
        while (start <= end){
            options.push(<MenuItem value={start}>{start}</MenuItem>)
            start++
        }
    } else{
        while (start >= end){
            options.push(<MenuItem value={start}>{start}</MenuItem>)
            start--
        }
    }
    return options
}



export default DateOfBirth;